module.exports = __webpack_public_path__ + "img/plate_parked.a2905192.svg";